import React from 'react'

export const RegularData = ({ value }) => (
    <b>
        {value}
    </b>
);


